define(function(require, exports, module) {
    'use strict';

    const user = require('user');
    const i18n = require('i18n');
    const Form = require('class/form.class');
    const BaseReplacerView = require('common/base.replacer.view');

    module.exports = BaseReplacerView.extend({
        accessRules: {
            allow: ['user']
        },

        events: {
            'tap .field_name_consequences input': 'toggleSubmit',
            'submit form': 'showPermanentExclusionPopup'
        },

        render: function() {
            this.$el.html(this.tmpl('permanent-exclusion'));

            this.form = new Form(this.$('form'));
            this.submit = this.$('.btn[type=submit]')[0];

            return this;
        },

        toggleSubmit: function() {
            this.submit.disabled = !this.form.isDataChanged();
        },

        showPermanentExclusionPopup: function(e) {
            e.preventDefault();

            const translationKey = 'playtech.mobile.system.permanent-exclusion.popup.';

            window.Playtech.API.popup.showPopup({
                className: 'permanent-exclusion__popup',
                title: i18n.t(translationKey + 'title'),
                content: i18n.t(translationKey + 'description'),
                buttons: [
                    {
                        text: i18n.t(translationKey + 'confirm'),
                        onClick: () => {
                            user.requestPermanentExclusion()
                                .done(() => {
                                    user.set('userDetails', {
                                        ...user.get('userDetails'),
                                        custom20: 'PERMANENTEXCLUSION'
                                    });
                                })
                                .fail(() => {
                                    window.Playtech.API.popup.showPopup({
                                        content: i18n.t(translationKey + 'error'),
                                        buttons: [
                                            {
                                                text: i18n.t('playtech.mobile.system.message.ok')
                                            }
                                        ]
                                    });
                                });
                        }
                    }
                ]
            });
        }
    }, {
        nameOfReplacers: [
            'PERMANENT_EXCLUSION'
        ]
    });
});
